<template>
<div>
    <Breadcrumb :title="'Direct Investment Valuation Upload'"></Breadcrumb>
    <div class="row no-gutters">
        <div class="col">
            <button class="btn btn-primary" style="float:right;" @click.prevent='downloadTemplate'><span class="fa fa-download"></span> Download Template</button>
            <button class="btn btn-secondary" style="float:right;margin-right:10px;" @click.prevent='backtoDirectInvestment'>
                <span class="k-icon k-i-undo" >  </span> &nbsp;Back to Direct Investment
                </button>
           
        </div>
    </div>
    <div class="row">
        <br>

</div>
        <BaseAuditDropzone ref="ParentFileUploaded" :id="'DirectInvestmentValuation'" :acceptedFileTypes="SheetJSFT" @change="_change"  @Remove="ClearForm" :File="inputfile" :UploadType="FileUploadType"></BaseAuditDropzone>
        <br><br>
        <div ref="refCustomerror"
        id="Customerror"
        class="alert alert-danger"
        role="alert"
        v-show="pageErrors.length"
        >
        <span v-show="pageErrors.length" class="alert-danger">
            <b>Please correct the following error(s):</b>
            <ul>
            <li v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
        </span>
        </div>
        <div v-show="displayPage">
        <div class="row no-gutters" >
            <div class="col">
                <div class="form-row">
                    <div class="col-md-12">
                        <BaseGrid :mode="'editform'" :config="DirectInvestmentUploadGridConfig" :data="dataDIExcel" @DeleteItem="DeleteDIfromGrid">
                            <!-- @EditItem="EditPartner"  -->
                        </BaseGrid>
                    </div>
                </div>
            </div>
        </div>
        
            <div class="row">
                <br>

</div>
                <div class="row no-gutters" style='float: right;margin-left:15px;'>
                    <button type="button" id="btnSave" class="btn btn-primary" :disabled="(!isValid|| pageErrors.length>0 || dataDIExcel.length<=0)" @click.prevent="SaveDirectInvestment">Save</button>

                </div>
                <div class="row no-gutters" style='float: right;'>
                    <button type="button" id="btnSave" class="btn btn-secondary" @click.prevent="validateFn">Validate</button>
                </div>
                <div class="row">
                    <br><br>

</div>
                </div>

            </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import customAxios from "@/services/customAxios.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import sheetJSConfig from "@/configs/sheetJS.js";
import XLSX from "xlsx";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import BaseInvestment from '@/models/BaseModelInvestment.js';
import BasePartner from '@/models/BaseModelPartner.js';
import BaseAllocation from '@/models/BaseModelDirectInvestmentValuation.js';
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import { isNullOrUndefined } from "util";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";
import {
    mapActions,
    mapState,
    mapGetters
} from 'vuex';
import {
    DirectInvestmentUploadGridConfig
} from '@/views/valuation/DirectInvestmentValuationUploadConfig.js'
import BaseModelDirectInvestmentValuation from '@/models/BaseModelDirectInvestmentValuation.js'
export default {
    components: {
        BaseGrid,
        Breadcrumb,
        BaseAuditDropzone,
    },
    mixins: [apiUtil, funcUtil,DocumentManagerMixin],
    data() {
        return {
            data: "",
            inputfile: {
                UploadFile: {}
            },
            //UploadFile:excelfile,
            displayPage: false,
            FileUploadType: {
                AllowMultiple: "false"
            },
            SheetJSFT: sheetJSConfig.fileType,
            DirectInvestmentUploadGridConfig: DirectInvestmentUploadGridConfig,
            dataDIExcel: [],
            pageErrors: [],
            PartnerAPIData: [],
            InvestmentAPIData: [],
            TaxYearOptions:[],
            TaxQuarterOptions:[],
            BaseModelInputControl:BaseModelInputControl,
            Columns:[],
            isValid:false,
            bulkUploadAuditConfig: bulkUploadAuditConfig
        };
    },
    
    computed: {
        ...mapState("postModule", ["response"]),
        ...mapGetters("getModule", ["getAllItemFilter","getLocalInputControls"])
    },
    methods: {
        ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
        _suppress(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        },
        downloadTemplate() {
            let token = localStorage.getItem("eum")
           let tokenstr = `Bearer ${token}`
           let templateUrl = getUrl("DirectInvestmentExcel");
           let templateFileName = getFileName("DirectInvestmentExcel");
            
           customAxios({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
        },

        _drop(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            const files = evt.BaseModelTransfer.files;
            if (files && files[0]) this._file(files[0]);
        },
        _change(evt) {
            const files = this.inputfile.UploadFile[0];
            if (files) this._file(files);
        },
        _export(evt) {
            /* convert state to workbook */
            const ws = XLSX.utils.aoa_to_sheet(this.data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
            /* generate file and send to client */
            XLSX.writeFile(wb, "sheetjs.xlsx");
        },
        backtoDirectInvestment: function() {
      this.$router.push("/valuation/directinvestment");
        },
        _file(file) {
            /* Boilerplate to set up FileReader */
            try {
                const XLSX = require("xlsx");
                const reader = new FileReader();
                reader.onload = e => {
                    /* Parse data */
                    //const bstr = e.target.result;
                    let binary = "";
                    let bytes = new Uint8Array(e.target.result);
                    let length = bytes.byteLength;

                    for (let i = 0; i < length; i++) 
                    {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    const bstr = binary
                    const wb = XLSX.read(bstr, {
                        type: "binary"
                    });
                    /* Get Partner  data */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, {
                        range: sheetJSConfig.template.header - 1, 
                        header: 1
                    });
                    console.log(data);
                    data.splice(0, 1);
                    if (data && data.length) {
                        //get partner and investment
                        this.Columns = [];
                        let response=this.getAllItemFilter({
                            Partner: {
                                config: BasePartner
                            },
                            Investment: {
                                config: BaseInvestment
                            }

                        });
                        if(response)
                        {
                            this.PartnerAPIData = response.Partner;
                            this.InvestmentAPIData = response.Investment;
                        }
                        //if (this.HeaderRow != "") {
                        this.displayPage = true;

                        var DIExcelArr = [];
                        var count = 1;
                        for (var i = 0; i < data.length; i++) {
                            var DIExcelObj = {};
                            DIExcelObj.DIKey = count++;
                            DIExcelObj.PartnerPartnerID = data[i][2];

                            DIExcelObj.InvestmentInvestmentID = data[i][0];                          
                            if(data[i][4])
                            {
                                 DIExcelObj.TaxYear = data[i][4].toString();
                            }
                            if(data[i][5])
                            {
                                 DIExcelObj.TaxQuarter = this._firstLetterToUpper(data[i][5]);
                            }

                            DIExcelObj.CommitmentFunded = data[i][6];
                            DIExcelObj.CommitmentRemaining = data[i][7];
                            DIExcelObj.PriorCashDistribution = data[i][8];
                            DIExcelObj.ProjectedValue = data[i][9];
                            DIExcelObj.CurrentValue = data[i][10];

                            DIExcelArr.push(DIExcelObj);
                        }
                        this.dataDIExcel = DIExcelArr;
                        this.getPartnerDetails();
                        this.getInvestmentDetails();

                        var grid = $("#DirectInvestmentUploadGrid").data("kendoGrid");

                        grid.dataSource.data(this.dataDIExcel);
                        console.log(JSON.stringify(this.dataDIExcel));
                    }

                    /* Update state */
                    //this.data = data;
                    //console.log(JSON.stringify(data));
                };
                reader.readAsArrayBuffer(file);
            } catch (ex) {
                console.log(ex);
                //this.$Progress.fail();
            }
        },
        getPartnerDetails: function () {
            let partner = this.PartnerAPIData.slice();
            let dataDIExcel = this.dataDIExcel.slice();

            for (let i = 0; i < dataDIExcel.length; i++) {
                if (dataDIExcel[i].PartnerPartnerID) {
                    var result = partner.filter(function (obj) {
                        if(obj.PartnerID){
                        return (obj.PartnerID.toString().trim().toLowerCase() == dataDIExcel[i].PartnerPartnerID.toString().trim().toLowerCase());
                        }
                    })[0];
                    if (result) {
                        dataDIExcel[i].PartnerTitle = result.FullName;
                        dataDIExcel[i].PartnerId=result.Id; 
                    }
                }
            }

            this.dataDIExcel = dataDIExcel;

        },

        getInvestmentDetails: function () {
            let Investment = this.InvestmentAPIData.slice();
            let dataDIExcel = this.dataDIExcel.slice();

            for (let i = 0; i < dataDIExcel.length; i++) {
                if (dataDIExcel[i].InvestmentInvestmentID) {
                    var result = Investment.filter(function (obj) {
                        if(obj.InvestmentID)
                        {
                        return (obj.InvestmentID.toString().trim().toLowerCase() == dataDIExcel[i].InvestmentInvestmentID.toString().trim().toLowerCase());
                        }
                    })[0];
                    if (result) {
                        dataDIExcel[i].InvestmentTitle = result.Title;
                        dataDIExcel[i].InvestmentId=result.Id;
                    }
                }
            }
            this.dataDIExcel = dataDIExcel;
        },

        DeleteDIfromGrid: function (e) {
            //e.preventDefault();
            //alert("Delete button clicked from BaseGrid..");
            const message = "Are you sure you want to delete this record?";
             this._ConfirmationPopup(message,"DELETE").then((result) => {
             if (result.value) {
                var gview = window.$("#DirectInvestmentUploadGrid").data("kendoGrid");
                var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
                //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
                //alert(JSON.stringify(dataItem));
                let objIndex = this.dataDIExcel.findIndex(
                    obj => obj.DIKey == dataItem.DIKey
                );
                this.dataDIExcel.splice(objIndex, 1);
                var grid = $("#DirectInvestmentUploadGrid").data("kendoGrid");
                grid.dataSource.data(this.dataDIExcel);
            }
             })
        },
        

        SaveDirectInvestment: function () {
            const self = this;
            let NewDirectInvestmentobject = {
                DirectInvestmentValuation: {
                    config: BaseModelDirectInvestmentValuation,
                    createData: this.dataDIExcel.slice()
                }
            };
            //this._createAllItems(NewPartnerobject).then(addnewpartner => {
            //let loader = this.$loading.show();
             self._APICrudPopup("APICrudpopup");
            this.CreateAllItems(NewDirectInvestmentobject).then(DirectInvestmentValuation => {
                console.log(DirectInvestmentValuation);
                //self._AlertPopup("Direct Investment data saved successfully", "success");
                /** AUDIT DOCUMENT UPLOAD **/
                let FileUpload = [];
                let senderObj = {};
                //senderObj.Id = this.count++;
                let realfileName = this.inputfile.UploadFile[0].name;
                // senderObj.File = self._appendDatewithExcelName(fileName);
                senderObj.File = this.inputfile.UploadFile[0].upload.uuid
                senderObj.RealFileName = realfileName;
                senderObj.FileContent = this.inputfile.UploadFile[0];
            FileUpload.push(senderObj);
            this.UploadBulkAditFilesToDB(FileUpload, true)
                .then(response => {
                self._AlertPopup("Direct Investment data saved successfully", "success");
                })
                .catch(error => {
                self._AlertPopup("Some Error Occurred!", "info");
                })
                .finally(() => {
                //loader.hide();
                });
            /** AUDIT DOCUMENT UPLOAD END */
                this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
            }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
                //loader.hide();
            })
        },
        validateFn(e){
            let self = this;
            e.preventDefault();
            let dataItem = $("#DirectInvestmentUploadGrid").data("kendoGrid").dataSource.data();
            self.pageErrors=[];
            let errorMessages = new Set();
            
            self.isValid = true;
             
            dataItem.forEach((ele,i) => {
                self.Columns = []
                let pIndex = self.PartnerAPIData.findIndex(f => f.PartnerID == ele.PartnerPartnerID)
                if( ele.PartnerPartnerID =="" || isNullOrUndefined(ele.PartnerPartnerID)||pIndex < 0){
                    self.Columns.push({"column":"PartnerPartnerID","row":i});
                     errorMessages.add("Partner ID is Empty or Invalid.")
                }
                let investIndex = self.InvestmentAPIData.findIndex(f => f.InvestmentID == ele.InvestmentInvestmentID)
                if(ele.InvestmentInvestmentID =="" || isNullOrUndefined(ele.InvestmentInvestmentID) ||investIndex < 0){
                    self.Columns.push({"column":"InvestmentInvestmentID","row":i});
                    errorMessages.add("Investment ID is Empty or Invalid.")
                }
                let TaxYIndex = self.TaxYearOptions.findIndex(f => f.Option == ele.TaxYear)
                if(ele.TaxYear =="" || isNullOrUndefined(ele.TaxYear)||TaxYIndex < 0){
                    self.Columns.push({"column":"TaxYear","row":i});
                    errorMessages.add("Tax Year is Empty or Invalid.")
                }
                let TaxQIndex = self.TaxQuarterOptions.findIndex(f => f.Option == ele.TaxQuarter)
                if(ele.TaxQuarter =="" || isNullOrUndefined(ele.TaxQuarter)||TaxQIndex < 0){
                    self.Columns.push({"column":"TaxQuarter","row":i});
                    errorMessages.add("Tax Quarter is Empty or Invalid.")
                }
                
                if(isNaN(ele.CommitmentFunded)|| ele.CommitmentFunded ==null){
                    self.Columns.push({"column":"CommitmentFunded","row":i});
                     errorMessages.add("Commitment Funded is Empty or Invalid.");
                }
                if(isNaN(ele.CommitmentRemaining)|| ele.CommitmentRemaining==null){
                    self.Columns.push({"column":"CommitmentRemaining","row":i});
                     errorMessages.add("Commitment Remaining is Empty or Invalid.");
                }
                if(isNaN(ele.PriorCashDistribution)||ele.PriorCashDistribution==null){
                    self.Columns.push({"column":"PriorCashDistribution","row":i});
                    errorMessages.add("Prior Cash Distribution is Empty or Invalid.");
                }
                if(isNaN(ele.ProjectedValue)|| ele.ProjectedValue ==null){
                    self.Columns.push({"column":"ProjectedValue","row":i});
                     errorMessages.add("Projected Value is Empty or Invalid.");
                }
                 if(isNaN(ele.CurrentValue)||ele.CurrentValue==null){
                    self.Columns.push({"column":"CurrentValue","row":i});
                    errorMessages.add("Current value is Empty or Invalid.")
                }
                self.Columns.push({"column":"Validation","row":i});

                if(self.Columns.length != 1 && self.isValid){
                    self.isValid = false;
                }

                self.ValidateImportData('DirectInvestmentUploadGrid',self.Columns);

            })
            self.pageErrors=[...errorMessages]
        },

        ClearForm() {    
            this.dataDIExcel=[]  
            this.displayPage = false;
            this.pageErrors=[];
            this.isValid=false;
        },

    },

    mounted() {
        let self = this;
         let response = self.getLocalInputControls(
            self.BaseModelInputControl.list
         );

        this.TaxYearOptions=response.TaxYear;
        this.TaxQuarterOptions=response.TaxQuarter; 
    }
};
</script>

